import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=51d98e37&scoped=true&"
import script from "./CustomerContact.vue?vue&type=script&lang=js&"
export * from "./CustomerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d98e37",
  null
  
)

export default component.exports